import axiosClient from "../apiClient";

export const getTemplateListing = async (pageNumber) => {
  return await axiosClient.get(`video-template?page=${pageNumber}&limit=7`);
};

export const getTemplateDetail = async (templateId) => {
  return await axiosClient.get(`video-template/${templateId}`);
};

export const findTemplate = async (pageNumber, query) => {
  return await axiosClient.get(
    `admin/searchTemplate?searchKey=${query}&page=${pageNumber}&limit=7`
  );
};

export const deleteTemplate = async (templateId) => {
  return await axiosClient.delete(`video-template/${templateId}`);
};

// Flip a template between free and premium (JSON, lightweight — no re-upload).
export const setTemplateTier = async (templateId, isFree) => {
  return await axiosClient.patch(`video-template/${templateId}/tier`, {
    isFree,
  });
};

export const addTemplate = async (data, onUploadProgress) => {
  const formData = new FormData();
  formData.append("name", data?.title);
  formData.append("videoTemplate", data?.videoTemplate);
  formData.append("suitableFor", data?.suitableFor);
  formData.append("description", data?.description);
  formData.append("categoryId", data?.id);
  formData.append("isFree", data?.isFree ? "true" : "false");

  // Let failures propagate (instead of swallowing them into `undefined`) so the caller
  // can show the server's actual error message rather than a generic one.
  return await axiosClient.post(`video-template`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    // Video files can run to hundreds of MB, and the server does ffmpeg processing +
    // two S3 uploads on top of the transfer itself; without a generous timeout a
    // stalled request leaves the "Saving..." button spinning forever with no error.
    timeout: 15 * 60 * 1000,
    onUploadProgress,
  });
};

export const changeTemplate = async (templateData, onUploadProgress) => {
  const formData = new FormData();
  formData.append("name", templateData?.title);
  if (templateData?.image instanceof File) {
    formData.append("videoTemplate", templateData.image);
  }
  formData.append("suitableFor", templateData?.suitableFor);
  formData.append("description", templateData?.description);
  formData.append("categoryId", templateData?.categoryId);

  return await axiosClient
    .patch(`video-template/${templateData.id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 15 * 60 * 1000,
      onUploadProgress,
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getCategoryNames = async () => {
  return await axiosClient(`categories?page=1&limit=20`);
};
